import axios from 'axios';

const baseURL = `${process.env.REACT_APP_API_URL}`;

export const productSubCategoryAPI = {
  add: async (info) => axios.post(`${baseURL}/sub-category`, info).then((res) => res.data),
  all: async () => axios.get(`${baseURL}/sub-category`).then((res) => res.data),
  single: async (idToSearch) => axios.get(`${baseURL}/sub-category/${idToSearch}`).then((res) => res.data),
  update: async (idToSearch) => {
    const { id, ...details } = idToSearch;
    return axios.put(`${baseURL}/sub-category/${id}`, details).then((res) => res.data);
  },
  delete: async (idToSearch) => axios.delete(`${baseURL}/sub-category/${idToSearch}`).then((res) => res.data)
};
